import { motion } from "framer-motion";
import { PrimaryCTA, GhostCTA } from "@/components/shared/CTA";
import { track, EVENTS } from "@/lib/analytics";
import { container, lineReveal, reveal } from "./motion";

export const AboutHero = () => (
  <section data-testid="about-hero" className="flex min-h-[88vh] flex-col justify-center px-6 pt-32 md:px-16 lg:px-24">
    <motion.div variants={container} initial="hidden" animate="show" className="max-w-5xl">
      <motion.p variants={reveal} className="mb-8 font-mono text-[11px] uppercase tracking-[0.45em] text-[#06B6D4]">
        About the Studio
      </motion.p>
      <h1 className="font-display font-black leading-[1.02] tracking-tight">
        <span className="block overflow-hidden">
          <motion.span
            variants={lineReveal}
            data-testid="about-title"
            className="block bg-gradient-to-r from-[#F4F6FB] via-[#c9b8f5] to-[#7dd8ea] bg-clip-text text-4xl uppercase text-transparent md:text-6xl lg:text-7xl"
          >
            Elentara is an immersive design studio.
          </motion.span>
        </span>
      </h1>
      <motion.p variants={reveal} className="mt-8 max-w-2xl text-lg leading-relaxed text-[#F4F6FB]/75 md:text-xl">
        We craft 3D digital experiences, creative technology, and interactive brand worlds —
        places where imagination becomes reality.
      </motion.p>
      <motion.div variants={reveal} className="mt-12 flex flex-wrap items-center gap-5">
        <PrimaryCTA
          to="/start-a-project"
          testId="about-cta-button"
          onClick={() => track(EVENTS.START_PROJECT_CLICK, { from: "about-hero" })}
        >
          Start a Project
        </PrimaryCTA>
        <GhostCTA to="/work" testId="about-explore-work-button">
          Explore Our Work
        </GhostCTA>
      </motion.div>
    </motion.div>
  </section>
);

export default AboutHero;
